import React, { VFC } from "react";
import { makeStyles } from "@material-ui/core";

import Container from "@eGroupTeam/material/Container";
import Typography from "@eGroupTeam/material/Typography";
import Grid from "@eGroupTeam/material/Grid";
import { Box } from "@eGroupTeam/material";

import oneStepImg from "./images/one-step.svg";
import anyDeviceImg from "./images/support-any-device.svg";
import reduceCostImg from "./images/reduce-cost.svg";

const useStyles = makeStyles((theme) => ({
  valueSection: {
    marginTop: "4rem",
  },
  contentWrapper: {
    backgroundColor: theme.egPalette.info[2],
    borderRadius: "30px 30px 0 0",
    padding: "3rem 1rem",
    "& h2": {
      color: theme.palette.common.white,
      fontSize: "23px",
      marginBottom: "2rem",
      lineHeight: "1.2",
    },
  },
  valueItem: {
    "& img": {
      width: "100px",
      height: "100px",
      objectFit: "fill",
    },
    "& h4": {
      color: theme.palette.common.white,
      fontSize: "1.5rem",
      lineHeight: "1.2",
      marginBottom: "0.5rem",
    },
    "& p": {
      fontSize: "12px",
      color: theme.palette.common.white,
    },
  },
}));

const MiceValueSection: VFC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.valueSection}>
      <Container>
        <Box className={classes.contentWrapper}>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="h2" fontWeight={500} align="center">
                為什麼選擇 MICEPass
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <Box textAlign="center" className={classes.valueItem}>
                <img src={oneStepImg} alt="One Step" decoding="async" />
                <Typography variant="h4" fontWeight={500} align="center">
                  一站式服務平台
                </Typography>
                <Typography variant="body1" align="center">
                  完整的活動功能
                </Typography>
                <Typography variant="body1" align="center">
                  涵蓋活動事前、事中、事後
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <Box textAlign="center" className={classes.valueItem}>
                <img src={anyDeviceImg} alt="One Step" decoding="async" />
                <Typography variant="h4" fontWeight={500} align="center">
                  支援各種裝置
                </Typography>
                <Typography variant="body1" align="center">
                  開啟瀏覽器，就能辦活動
                </Typography>
                <Typography variant="body1" align="center">
                  不需要安裝APP
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <Box textAlign="center" className={classes.valueItem}>
                <img src={reduceCostImg} alt="One Step" decoding="async" />
                <Typography variant="h4" fontWeight={500} align="center">
                  降低活動成本
                </Typography>
                <Typography variant="body1" align="center">
                  高度智能化與資訊化平台
                </Typography>
                <Typography variant="body1" align="center">
                  降低活動人力與行政成本
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default MiceValueSection;
